'use client';

import { css } from 'styled-components';
import { theme } from '@frameio/vapor-theme';

export const baseTextStyles = {
  fontFamily: theme.fonts.body,
  lineHeight: 'var(--line-height)',
  margin: 0,
  WebkitTextSizeAdjust: 'none',
} as const;

export const textVariants = {
  titleLarge: {
    fontFamily: 'heading',
    fontWeight: theme.fontWeights.semiBold,
    fontSize: theme.fontSizes['500'],
    lineHeight: theme.lineHeights['300'],
    letterSpacing: '-0.0075em',
  },
  titleMedium: {
    fontFamily: 'heading',
    fontWeight: theme.fontWeights.semiBold,
    fontSize: theme.fontSizes['400'],
    lineHeight: theme.lineHeights['250'],
    letterSpacing: '-0.0075em',
  },
  titleSmall: {
    fontFamily: 'heading',
    fontWeight: theme.fontWeights.semiBold,
    fontSize: theme.fontSizes['200'],
    lineHeight: theme.lineHeights['200'],
  },
  subtitleLarge: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes['100'],
    lineHeight: theme.lineHeights['200'],
  },
  subtitleMedium: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes['95'],
    lineHeight: theme.lineHeights['200'],
  },
  subtitleSmall: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes['70'],
    lineHeight: theme.lineHeights['100'],
  },
  header: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes['90'],
    lineHeight: theme.lineHeights['100'],
  },
  primary: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes['80'],
    lineHeight: theme.lineHeights['100'],
  },
  secondary: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes['60'],
    lineHeight: theme.lineHeights['50'],
  },
  body: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes['70'],
    lineHeight: theme.lineHeights['100'],
  },
  link: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes['70'],
    lineHeight: theme.lineHeights['100'],
  },
  linkSmall: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes['60'],
    lineHeight: theme.lineHeights['100'],
  },
  caption: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes['50'],
    lineHeight: theme.lineHeights['50'],
  },
} as const;

export const textStyles = Object.fromEntries(
  Object.entries(textVariants).map(
    ([key, { lineHeight, fontFamily, ...variantTextStyles }]) => [
      key,
      css({
        margin: 0,
        WebkitTextSizeAdjust: 'none',
        '--line-height': lineHeight,
        lineHeight: `var(--line-height)`,
        fontFamily: theme.fonts[fontFamily],
        ...variantTextStyles,
      }),
    ]
  )
) as { [K in keyof typeof textVariants]: ReturnType<typeof css> };
